import abortable from "../../../utilities/abortable"

function Endpoint(endpoint) {
	let controller = abortable()

	return {
		async fetch(params = {}, opts = {}) {
			let url = new URL(`https://liveapi.yext.com/v2/accounts/me/${endpoint}?api_key=001413b1dcb703b70a910d3415bfa41b&v=20210701`);

			// Add additional query parameters
			Object.entries(params).forEach(([key, val]) => {
				if (typeof val === 'string') {
					url.searchParams.set(key, val);
				} else {
					url.searchParams.set(key, JSON.stringify(val));
				}
			})

			// Send the request
			const res = await controller.fetch(url.toString(), opts);
			const json = await res.json();

			// Log errors
			if (json?.meta?.errors?.length) {
				json.meta.errors.forEach(err => {
					console.error(`Error ${err.code}: ${err.message}`)
				})
			}

			// Return json response
			return json?.response ?? {};
		},

		abort() {
			controller.abort();
		}
	}
}

export const GeoSearch = Endpoint('entities/geosearch');
